import React from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import SeeAllLink from 'components/SeeAllLink';
import _isEmpty from 'lodash/isEmpty';
import AppContainer from 'components/AppContainer';
import Carousel from 'components/Carousel';
import CarouselContainer from 'components/Carousel/CarouselContainer';
import { makeStyles } from '@material-ui/core/styles';
import useWindowSize from 'components/useWindowSize';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { makeSelectClientLanding } from 'containers/ClientLanding/selectors';
import { useQuery } from 'react-query';
import _get from 'lodash/get';
import LoadingSkeleton from 'components/LoadingSkeleton';
import { getHomeResources } from '../services/api';
import ResourcesLinkBtn from './ResourcesLinkBtn';
import AllResourcesListSet from './AllResourcesListSet';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('480')]: {
      position: 'relative',
    },
  },
  viewMore: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const stateSelector = createStructuredSelector({
  clientLanding: makeSelectClientLanding(),
  clientDetails: makeSelectClientDetails(),
});

function AllResourcesList() {
  const classes = useStyles();
  const { width } = useWindowSize();
  const isMobile = width <= 600 && width > 470;
  const allMobileSize = width < 600;
  const { clientLanding, clientDetails } = useSelector(stateSelector);
  const limit = allMobileSize ? 6 : 12;
  const { data, status, isFetching } = useQuery(
    ['h-all', limit, clientDetails, clientLanding],
    getHomeResources,
  );
  const showSkeleton =
    _isEmpty(_get(data, 'hits')) || status === 'loading' || isFetching;
  const customProps = isMobile ? { centerMode: true } : null;
  return (
    <AppContainer topPadding={isMobile} noPadding>
      <Grid container spacing={2} className={classes.root}>
        <ResourcesLinkBtn link="resources" />
        <CarouselContainer>
          <Carousel customProps={customProps}>
            {showSkeleton &&
              Array.from(new Array(4)).map((_, index) => (
                <LoadingSkeleton key={index} />
              ))}
            {!showSkeleton &&
              data.hits.map(item => (
                <AllResourcesListSet item={item} key={item.slug} />
              ))}
          </Carousel>
        </CarouselContainer>
        <Hidden smUp>
          <Grid item xs={12} className={classes.viewMore}>
            <SeeAllLink
              link="resources"
              label="View All"
              align="center"
              bordered
              isMobile
            />
          </Grid>
        </Hidden>
      </Grid>
    </AppContainer>
  );
}

export default AllResourcesList;
